import { render, staticRenderFns } from "./deprecation-banner.vue?vue&type=template&id=5ef29448&scoped=true&"
import script from "./deprecation-banner.vue?vue&type=script&lang=js&"
export * from "./deprecation-banner.vue?vue&type=script&lang=js&"
import style0 from "./deprecation-banner.vue?vue&type=style&index=0&id=5ef29448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef29448",
  null
  
)

export default component.exports